import axios from "axios";
import constants from "../constants/index";

const axiosClientPublic = async (
  url,
  method,
  params,
  data,
  timeout,
  contentType = "application/json",
  responseType = "",
) => {
  const headers = {
    Accept: "application/json",
    "Content-Type": contentType,
    "Accept-Language":"vi"
  };
 
  const axiosSetup = {
    url,
    method,
    headers,
    params,
    data,
    timeout: timeout ?? constants.TIMEOUT_REQUEST,
    dataType: "json",
    responseType: responseType,
  };
  return axios(axiosSetup);
};

export default axiosClientPublic;
